import { render, staticRenderFns } from "./equipmentBuyMine.vue?vue&type=template&id=f2bcb588&scoped=true"
import script from "./equipmentBuyMine.vue?vue&type=script&lang=js"
export * from "./equipmentBuyMine.vue?vue&type=script&lang=js"
import style0 from "./equipmentBuyMine.vue?vue&type=style&index=0&id=f2bcb588&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bcb588",
  null
  
)

export default component.exports